import React, { Component } from "react";
import axios from "axios";
import { ENDPOINT } from "../../utils/index";
import { resolveMedia } from "./embedMedia";
import EmbedViewer from "./EmbedViewer";
import "./bunkeyHostEmbed.css";

// Se llama a axios directo y no a api/BunkeyAPI: ese interceptor hace
// history.push('/logout') ante 401/403 — dentro del Switch aislado del embed
// (App.js) esa ruta no existe y el iframe queda en blanco — y además adjunta el
// Bearer del usuario, innecesario en un endpoint público.
export class BunkeyHostEmbed extends Component {
  constructor(props) {
    super(props);
    this.state = { status: "loading", data: null };
  }

  componentDidMount() {
    document.documentElement.classList.add("bunkey-embed");
    document.body.classList.add("bunkey-embed");

    const { id, quality } = this.props.match.params;
    if (!id) {
      this.setState({ status: "notfound" });
      return;
    }

    axios
      .get(`${ENDPOINT}embed/${id}`)
      .then(resp => {
        const data = resp && resp.data && resp.data.result;
        if (!data) {
          this.setState({ status: "notfound" });
          return;
        }
        this.setState({ status: "ready", data, media: resolveMedia(data, quality) });
      })
      .catch(err => {
        // objects devuelve 504 para asset inexistente, no 404 (ObjectError.js)
        const status = err && err.response && err.response.status;
        this.setState({
          status: status === 404 || status === 504 ? "notfound" : "error"
        });
      });
  }

  componentWillUnmount() {
    document.documentElement.classList.remove("bunkey-embed");
    document.body.classList.remove("bunkey-embed");
  }

  renderContent() {
    const { status, data, media } = this.state;

    if (status === "loading") {
      return <div className="bk-embed__spinner" />;
    }

    if (status === "ready") {
      return <EmbedViewer media={media} data={data} />;
    }

    // notfound y error muestran lo mismo: nada de reintentos ni detalles
    // técnicos en la página de un cliente.
    return (
      <div className="bk-embed__placeholder">
        <span>Contenido no disponible.</span>
      </div>
    );
  }

  render() {
    return <div className="bk-embed">{this.renderContent()}</div>;
  }
}

export default BunkeyHostEmbed;
